<template>
  <div
    class="vx-floating-input"
    :class="{
      'vx-floating-input--has-icon': icon,
      'vx-floating-input--danger': danger,
      'vx-floating-input--success': success,
      'vx-floating-input--disabled': disabled,
    }"
  >
    <i
      v-if="icon"
      class="vx-floating-input__icon"
      :class="[iconPack, icon]"
    ></i>
    <input
      ref="input"
      :type="type"
      :name="name"
      :value="value"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :class="inputClass"
      placeholder=" "
      @input="onInput"
      @change="$emit('change', $event)"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />
    <label>{{ labelText }}</label>
    <div
      v-if="danger && dangerText"
      class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
    >
      <span class="span-text-validation">{{ dangerText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "vx-floating-input",
  props: {
    value: {
      default: undefined,
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    labelPlaceholder: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    iconPack: {
      type: String,
      default: "feather",
    },
    autocomplete: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    danger: {
      type: Boolean,
      default: false,
    },
    dangerText: {
      type: String,
      default: "",
    },
    success: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: [String, Array, Object],
      default: "",
    },
  },
  computed: {
    labelText() {
      return this.labelPlaceholder || this.placeholder;
    },
  },
  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
      this.$emit("update:modelValue", event.target.value);
    },
    getValue() {
      return this.$refs.input ? this.$refs.input.value : "";
    },
    focus() {
      if (this.$refs.input) this.$refs.input.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.vx-floating-input {
  position: relative;

  input {
    background: transparent;
    border: 1px solid rgba(var(--vs-primary), 0.2);
    border-radius: 5px;
    color: inherit;
    font-size: 1rem;
    line-height: 1.4;
    min-height: 38px;
    outline: 0;
    padding: 0.7rem 0.8rem;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    width: 100%;

    &:focus {
      border-color: rgba(var(--vs-primary), 1);
      box-shadow: 0 0 0 2px rgba(var(--vs-primary), 0.12);
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
      background: #fff;
      color: rgba(var(--vs-primary), 1);
      font-size: 0.75rem;
      padding: 0 0.25rem;
      top: -0.45rem;
    }
  }

  label {
    color: rgba(0, 0, 0, 0.45);
    left: 0.8rem;
    line-height: 1;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: top 0.18s ease, font-size 0.18s ease, color 0.18s ease;
  }
}

.vx-floating-input--has-icon {
  input {
    padding-left: 2.55rem;
  }

  label {
    left: 2.55rem;
  }

  input:focus + label,
  input:not(:placeholder-shown) + label {
    left: 0.8rem;
  }
}

.vx-floating-input__icon {
  color: rgba(var(--vs-primary), 1);
  font-size: 1rem;
  left: 0.85rem;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.vx-floating-input--danger input {
  border-color: rgba(var(--vs-danger), 1);
}

.vx-floating-input--success input {
  border-color: rgba(var(--vs-success), 1);
}

.vx-floating-input--disabled {
  opacity: 0.65;
}
</style>
